/* Pic Presso site-wide touches (loaded on every page from layout/theme.liquid) */
(function () {
  // A melted-coffee edge under the announcement bar, in the bar's own color.
  // Drips are [position 0-1, depth in px]; the path is drawn at the bar's real pixel
  // width so drips keep their shape on every screen size. Beads fall from some drips.
  var DESKTOP = [[0.08, 15], [0.27, 26], [0.5, 13], [0.71, 23], [0.9, 17]];
  var MOBILE = [[0.14, 17], [0.45, 24], [0.8, 19]];
  var BASE = 3;

  function meltPath(width, drips) {
    var d = 'M0 0 H' + width + ' V' + BASE;
    var x = width;
    drips.slice().sort(function (a, b) { return b[0] - a[0]; }).forEach(function (drip) {
      var cx = Math.round(drip[0] * width);
      var depth = drip[1];
      var neck = 4 + depth * 0.12;      // half-width where the drip hangs
      var bulb = neck + 2.5;             // rounded drop at the tip
      var shoulder = neck + 14;          // where it flows out of the edge
      d += ' L' + (cx + shoulder) + ' ' + BASE;
      d += ' C' + (cx + neck + 3) + ' ' + BASE + ' ' + (cx + neck) + ' ' + (BASE + 4) + ' ' + (cx + neck) + ' ' + (depth - bulb);
      d += ' C' + (cx + neck) + ' ' + (depth + 1) + ' ' + (cx + bulb) + ' ' + (depth + bulb * 0.4) + ' ' + cx + ' ' + (depth + bulb * 0.45);
      d += ' C' + (cx - bulb) + ' ' + (depth + bulb * 0.4) + ' ' + (cx - neck) + ' ' + (depth + 1) + ' ' + (cx - neck) + ' ' + (depth - bulb);
      d += ' C' + (cx - neck) + ' ' + (BASE + 4) + ' ' + (cx - neck - 3) + ' ' + BASE + ' ' + (cx - shoulder) + ' ' + BASE;
      x = cx - shoulder;
    });
    return d + ' L0 ' + BASE + ' Z';
  }

  function drawMelt(wrap) {
    var width = Math.round((wrap.parentElement || wrap).clientWidth);
    if (width < 50 || width === wrap._ppWidth) return;
    wrap._ppWidth = width;
    var drips = width < 750 ? MOBILE : DESKTOP;
    var height = 34;
    wrap.querySelectorAll('svg, .pp-melt__drop').forEach(function (el) { el.remove(); });
    wrap.insertAdjacentHTML('afterbegin',
      '<svg viewBox="0 0 ' + width + ' ' + height + '" width="' + width + '" height="' + height + '" focusable="false"><path d="' + meltPath(width, drips) + '"/></svg>');
    drips.forEach(function (drip, i) {
      if (i % 2 === 1 && width < 750) return;
      var tip = drip[1] + (4 + drip[1] * 0.12 + 2.5) * 0.45;
      var bead = document.createElement('span');
      bead.className = 'pp-melt__drop';
      bead.style.setProperty('--x', Math.round(drip[0] * width) + 'px');
      bead.style.setProperty('--y', Math.round(tip - 3) + 'px');
      bead.style.setProperty('--s', drip[1] > 18 ? '7px' : '6px');
      bead.style.setProperty('--t', (6 + i * 1.3).toFixed(1) + 's');
      bead.style.setProperty('--delay', '-' + (i * 2.1).toFixed(1) + 's');
      wrap.appendChild(bead);
    });
  }

  function addMelt() {
    document.querySelectorAll('.announcement-bar:not([data-pp-melt])').forEach(function (bar) {
      bar.setAttribute('data-pp-melt', '');
      var color = getComputedStyle(bar).backgroundColor;
      var wrap = document.createElement('div');
      wrap.className = 'pp-melt';
      wrap.setAttribute('aria-hidden', 'true');
      if (color && color !== 'rgba(0, 0, 0, 0)' && color !== 'transparent') {
        wrap.style.setProperty('--pp-drip-color', color);
      }
      bar.appendChild(wrap);
      drawMelt(wrap);
      // the bar can be laid out after this runs (slider init), so redraw when it gets its width
      if ('ResizeObserver' in window) {
        new ResizeObserver(function () { drawMelt(wrap); }).observe(bar);
      }
    });
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('.pp-melt').forEach(drawMelt);
    }, 150);
  });

  // Cart icon gives a soft bump whenever the item count changes.
  function watchCartCount() {
    var icon = document.querySelector('#cart-icon-bubble');
    if (!icon || icon.hasAttribute('data-pp-watch') || !('MutationObserver' in window)) return;
    icon.setAttribute('data-pp-watch', '');
    var last = icon.innerText.trim();
    new MutationObserver(function () {
      var now = icon.innerText.trim();
      if (now === last) return;
      last = now;
      icon.classList.remove('pp-bump');
      void icon.offsetWidth;
      icon.classList.add('pp-bump');
    }).observe(icon, { childList: true, subtree: true, characterData: true });
  }

  // Free Shipping Protection over the threshold: add it automatically; if it was added
  // automatically and the cart drops below the threshold again, take it back out so the
  // shopper is never charged for something they did not choose.
  var AUTO_KEY = 'ppProtectionAuto';
  var protectionBusy = false;
  function store(key, value) {
    try { if (value === null) sessionStorage.removeItem(key); else sessionStorage.setItem(key, value); } catch (e) {}
  }
  function stored(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function checkProtection() {
    if (protectionBusy) return;
    var drawer = document.querySelector('cart-drawer');
    var info = drawer && drawer.querySelector('[data-pp-protection]');
    var toggle = drawer && drawer.querySelector('cart-drawer-upsell[data-handle] .upsell__toggle-switch');
    if (!info || !toggle) return;
    var eligible = info.getAttribute('data-eligible') === 'true';
    var has = info.getAttribute('data-has') === 'true';
    if (eligible && !has) {
      store(AUTO_KEY, '1');
    } else if (!eligible && has && stored(AUTO_KEY) === '1') {
      store(AUTO_KEY, null);
    } else {
      if (!has) store(AUTO_KEY, null);
      return;
    }
    protectionBusy = true;
    toggle.click();
    setTimeout(function () { protectionBusy = false; }, 2500);
  }
  function watchProtection() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.hasAttribute('data-pp-protect-watch') || !('MutationObserver' in window)) return;
    drawer.setAttribute('data-pp-protect-watch', '');
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(checkProtection, 400);
    }).observe(drawer, { childList: true, subtree: true });
    setTimeout(checkProtection, 800);
  }

  function init() {
    addMelt();
    watchCartCount();
    watchProtection();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', addMelt);
})();
